import { FilesService } from 'api';
import { DEFAULT_DOC_CONTENT_STALE_TIME_IN_MS } from 'components/Drawer/document-preview-drawer-tab/document-preview.constants';
import { fetchSpreadsheetData } from 'components/Drawer/document-preview-drawer-tab/xlsx-viewer/util';

export const XLSX_SPREADSHEET_NOTES_VERSION = 'v2';

export const xlsxSpreadsheetNotesQueryKey = (fileId?: string) => ['xlsxAsSpreadsheetNote', XLSX_SPREADSHEET_NOTES_VERSION, fileId];

export const xlsxSpreadsheetNotesQueryOptions = (fileId?: string) => ({
  queryKey: xlsxSpreadsheetNotesQueryKey(fileId),
  queryFn: async () => {
    if (!fileId) {
      throw new Error('Document file ID is missing');
    }
    const response = await FilesService.apiFilesProcessedRead(fileId, true);
    return fetchSpreadsheetData(response.url);
  },
  staleTime: DEFAULT_DOC_CONTENT_STALE_TIME_IN_MS,
  gcTime: DEFAULT_DOC_CONTENT_STALE_TIME_IN_MS,
  retry: false as const,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
});
